<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Id Confi Crtor Ws</label>

        <b-form-group :invalid-feedback="violations['idConfiCrtorWs']" :state="!violations['']">

          <b-form-input v-model="ssv2341ConfiCrtorFlagWs.idConfiCrtorWs" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Flag Ws</label>

        <b-form-group :invalid-feedback="violations['cdFlagWs']" :state="!violations['']">

          <b-form-input v-model="ssv2341ConfiCrtorFlagWs.cdFlagWs" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Ds Valor</label>

        <b-form-group :invalid-feedback="violations['dsValor']" :state="!violations['']">

          <select class="custom-select" v-model="ssv2341ConfiCrtorFlagWs.dsValor" placeholder="Valor da Flag" :required="true" :readonly="false">
            <option></option>

            <option value="S">Ligado</option>

            <option value="N">DEsligado</option>

          </select>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Ultma Alter</label>

        <b-form-group :invalid-feedback="violations['dtUltmaAlter']" :state="!violations['']">

          <date-picker v-model="ssv2341ConfiCrtorFlagWs.dtUltmaAlter" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Usuro Ultma Alter</label>

        <b-form-group :invalid-feedback="violations['cdUsuroUltmaAlter']" :state="!violations['']">

          <b-form-input v-model="ssv2341ConfiCrtorFlagWs.cdUsuroUltmaAlter" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2341ConfiCrtorFlagWs', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>